import EditPanel, { EditPanelProps } from '@/components/ui/Panels/EditPanel';
import { Address, AddressCategory, AddressCountry, AddressState } from '@/@types/client-api';
import { getTitle, isBillingAddress, isShippingAddress } from './utils';
import AddressForm from './AddressForm';
import useAddressForm from '@/hooks/addressForm';

type AddressPanelProps = {
  data?: Address;
  isInitialAddress?: boolean;
  onDelete?: (data: Address) => void;
  refetchAddresses?: () => void;
  setIsNewAddressAdded?: (value: boolean) => void;
  addressCategoryLookup: AddressCategory[];
  addressStateLookup: AddressState[];
  addressCountryLookup: AddressCountry[];
  type?: 'billing' | 'shipping';
} & Omit<EditPanelProps, 'children' | 'onSave' | 'onDelete' | 'title'>;

const AddressPanel: React.FC<AddressPanelProps> = ({
  isInitialAddress,
  isOpen,
  onOpenChange,
  theme,
  data,
  onDelete,
  refetchAddresses,
  setIsNewAddressAdded,
  addressCategoryLookup,
  addressStateLookup,
  addressCountryLookup,
  triggerButton,
  type
}) => {
  const isBillingOrShippingAddress =
    isInitialAddress || isBillingAddress(data) || isShippingAddress(data);

  const addressProps = useAddressForm(
    addressCategoryLookup,
    addressStateLookup,
    addressCountryLookup,
    undefined,
    refetchAddresses,
    setIsNewAddressAdded,
    onOpenChange,
    onDelete,
    data
  );

  return (
    <EditPanel
      title={getTitle(addressCategoryLookup, data)}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      theme={theme}
      onSave={addressProps.handleOnSave}
      onValidateFields={addressProps.handleValidateFields}
      onDelete={data && !isBillingOrShippingAddress ? addressProps.handleOnDelete : undefined}
      triggerButton={triggerButton}
    >
      <AddressForm
        isOpen={isOpen}
        isInitialAddress={isInitialAddress}
        data={data}
        type={type}
        {...addressProps}
      />
    </EditPanel>
  );
};

export default AddressPanel;
